import { render } from "./UnidadesMedida.vue?vue&type=template&id=0e90cf87&scoped=true"
import script from "./UnidadesMedida.vue?vue&type=script&lang=js"
export * from "./UnidadesMedida.vue?vue&type=script&lang=js"

import "./UnidadesMedida.vue?vue&type=style&index=0&id=0e90cf87&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e90cf87"]])

export default __exports__